<template>
    <PageLayout :title="title">
        <v-row>
            <v-col align="center" justify="center">
                <v-btn-toggle
                    v-model="phase"
                    background-color="#E0E0E0"
                    active-class="registration-button--active"
                    color="blue"
                    dense
                    mandatory
                    style="width: 100%;"
                    v-if="stepsCount > 1"
                >
                    <v-btn
                        width="120px"
                        small
                        :style="{ width: btnToggleWidth + '%' }"
                        class="disable-events"
                    >
                        {{ $t("step_counter", { number: "1" }) }}
                    </v-btn>
                    <v-btn
                        v-if="app_settings.payments.registration"
                        width="120px"
                        small
                        :style="{ width: btnToggleWidth + '%' }"
                        class="disable-events"
                    >
                        {{ $t("step_counter", { number: "2" }) }}
                    </v-btn>
                    <v-btn
                        v-if="!app_settings.skip_3_step"
                        width="120px"
                        small
                        :style="{ width: btnToggleWidth + '%' }"
                        class="disable-events"
                    >
                        {{ $t("step_counter", { number: stepsCount }) }}
                    </v-btn>
                </v-btn-toggle>
            </v-col>
        </v-row>

        <v-row v-if="!hideInfoBox">
            <v-col>
                <InfoBox :text="$t('get_now')" :icon="percentIcon"></InfoBox>
            </v-col>
        </v-row>

        <slot name="box"></slot>

        <v-row align="center" justify="center">
            <v-col cols="12" lg="8" md="8" sm="8">
                <v-app-bar
                    v-show="app_settings.show_i_need"
                    elevation="0"
                    :height="app_settings.show_slider ? 130 : 60"
                >
                    <v-row v-if="app_settings.show_slider" align="center" justify="center">
                        <v-col cols="12">
                            <div class="subtitle-1 font-weight-bold text-center">
                                {{ $t("choose_loan_value") }}
                                <span class="title font-weight-bold">{{ loanValue }}</span
                                >{{ $t("currency_symbol") }}
                            </div>
                        </v-col>
                        <v-col cols="12" class="mb-5">
                            <vue-slider
                                v-model="loanValue"
                                :min="app_settings.min"
                                :max="app_settings.max"
                                :interval="1000"
                                :tooltip="'always'"
                                :tooltip-formatter="formatter"
                                :tooltip-placement="'bottom'"
                                :style="cssValues"
                            ></vue-slider>
                        </v-col>
                    </v-row>
                    <v-row v-else align="center" justify="center">
                        <v-col cols="12">
                            <div class="subtitle-1 font-weight-bold text-center">
                                {{ $t("i_need") }}
                                <span class="title font-weight-bold">{{ loanValue }}</span
                                >{{ $t("currency_symbol") }}
                            </div>
                        </v-col>
                    </v-row>
                </v-app-bar>

                <v-progress-linear
                    v-if="!hideProgress"
                    :value="loanPossibility"
                    height="40"
                    class="gradient-progress"
                >
                    <span class="subtitle-2 font-weight-bold" style="font-size: 12px !important;">
                        {{ $t("approvement_chance", { loanPossibility }) }}
                    </span>
                </v-progress-linear>

                <slot></slot>
            </v-col>
        </v-row>
    </PageLayout>
</template>

<script>
import VueSlider from "vue-slider-component";
import PageLayout from "@/app/mobile/ui/PageLayout";
import InfoBox from "@/app/mobile/ui/InfoBox";
import percentIcon from "@/assets/img/icon-percent.png";

export default {
    name: "RegistrationLayout",
    components: {
        VueSlider,
        PageLayout,
        InfoBox,
    },
    props: ["loanPossibility", "phase", "title", "hideProgress", "hideInfoBox"],
    data() {
        return {
            formatter: (v) =>
                `${("" + v).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}` + this.$t("currency_symbol"),
            percentIcon: percentIcon,
        };
    },
    computed: {
        loanValue: {
            get() {
                return this.$store.getters.LOAN_VALUE;
            },
            set(value) {
                this.$store.dispatch("SET_LOAN_VALUE", value);
            },
        },
        startPossibility() {
            return this.$store.getters.START_LOAN_POSSIBILITY;
        },
        cssValues() {
            return {
                "--color": this.app_settings.primary_color,
            };
        },
        app_settings() {
            return this.$store.getters.APP_SETTINGS;
        },
        stepsCount() {
            return 1 + +!this.app_settings.skip_3_step + +this.app_settings.payments.registration;
        },
        btnToggleWidth() {
            return 100 / this.stepsCount;
        },
    },
};
</script>

<style lang="scss">
$themeColor: var(--color);
@import "~vue-slider-component/lib/theme/default.scss";
</style>
